import { ExtensionStudent } from './ManageExtension.types';

export const getConflictStudentIds = (detail = ''): string[] => {
  const match = detail.match(
    /students(?:\s*:\s*|\s+)(.*?)(?:\s+that are being removed from the extension|$)/
  );
  return match
    ? match[1]
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    : [];
};

export const getConflictStudents = (
  studentIds: string[],
  students: ExtensionStudent[]
): ExtensionStudent[] =>
  studentIds.map(
    (id) =>
      students.find((student) => student.id === id) || { id, fullName: id }
  );
